import { Patient } from "@jasper/client-models";
import {
  Button,
  Grid,
  Group,
  Paper,
  Stack,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconEdit, IconNumber1Small } from "@tabler/icons-react";
import { LabelledValue } from "./components/LabelledValue";
import { getAge, getGenderLabel } from "./patient.utils";

const getProfileText = ({ patient }: { patient: Patient }): string => {
  const { birthDate, sex } = patient;
  const defaultText = "Non renseigné";

  if (!birthDate && sex) {
    return getGenderLabel(sex) ?? defaultText;
  }

  if (birthDate && !sex) {
    return `${getAge(birthDate)} ans`;
  }

  if (birthDate && sex) {
    return `${getGenderLabel(sex)} - ${getAge(birthDate)} ans`;
  }

  return defaultText;
};

export const PatientSummary = ({
  patient,
  onEdit,
}: {
  patient: Patient;
  onEdit: () => void;
}) => {
  return (
    <Paper shadow="xs" p="xl" withBorder>
      <Stack>
        <Group justify="space-between">
          <Group>
            <ThemeIcon radius="xl" variant="light" c="primary">
              <IconNumber1Small />
            </ThemeIcon>
            <Title c="primary" order={5}>
              Patient
            </Title>
          </Group>
          <Button
            leftSection={<IconEdit size={16} />}
            variant="subtle"
            color="primary"
            onClick={onEdit}
          >
            Modifier
          </Button>
        </Group>

        <Grid>
          <Grid.Col span={4}>
            <LabelledValue
              label="Nom"
              text={`${patient.firstName} ${patient.lastName}`}
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <LabelledValue
              label="Profile"
              text={getProfileText({ patient }) ?? ""}
            />
          </Grid.Col>
        </Grid>
      </Stack>
    </Paper>
  );
};
